import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import { Image } from '@react-pdf/renderer'

// `src` is a ready-signed link. Share-code visitors have no session, so the
// server signs attachment links for them up front and the PDF must use those
// instead of asking /gets3downloadurl, which needs a logged-in user.
const MedicalDrawing = ({ imageKey, src, style }) => {
  const [image, setImage] = useState(null)

  useEffect(() => {
    let cancelled = false

    const toDataUrl = async (url) => {
      const resp = await fetch(url)
      if (resp.status !== 200) throw new Error('bad response')

      const blob = await resp.blob()
      const b64 = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result) // data:<mime>;base64,...
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
      return b64
    }

    const resolveUrl = async () => {
      if (src) return src
      if (!imageKey) return null

      const r = await API.post('/gets3downloadurl', {
        key: imageKey,
        ACL: 'public-read',
      })
      return r.status === 200 ? r.data : null
    }

    const run = async () => {
      const url = await resolveUrl()
      if (!url) return

      try {
        const dataUrl = await toDataUrl(url)
        if (!cancelled) setImage(dataUrl)
      } catch {
        if (!cancelled) setImage(null)
      }
    }

    run()
    return () => {
      cancelled = true
    }
  }, [imageKey, src])

  if (image) {
    return <Image src={image} style={{ height: 180, width: 180, ...style }} />
  } else {
    return null
  }
}

export default MedicalDrawing
